import { GET_DETAIL_SUCCESS, LOAD_DETAIL, CLEAR_DETAIL } from "../action_types";

const DEFAULT_CONFIG = { data: null, error: false, loading: false };

const DETAIL_CONFIG = [
  {
    name: "recipeShow"
  }
];

const initialState = {};
DETAIL_CONFIG.forEach((config) => {
  initialState[config.name] = {
    ...DEFAULT_CONFIG
  };
});

const showReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DETAIL_SUCCESS:
      return {
        ...state,
        [action.payload.name]: {
          ...state[action.payload.name],
          ...action.payload.response,
          error: false,
          loading: false
        }
      };
    case LOAD_DETAIL:
      return {
        ...state,
        [action.payload.name]: { ...state[action.payload.name], error: false, loading: true }
      };
    case CLEAR_DETAIL:
      return {
        ...state,
        [action.payload.name]: {
          ...DEFAULT_CONFIG
        }
      };
    default:
      return state;
  }
};

export default showReducer;
